import { Container, Row, Col } from "react-bootstrap";
import "../../design.css";
import DesignCard from "./DesignCards";
import PhotoGallery from "./PhotoGallery"
import { useContext } from "react";
import { AppContext } from "../../App";
import { useState } from "react";

import squash from "../../Assets/FoodStyling/squash.jpg";
import taipeiMag from "../../Assets/FoodStyling/taipeimag.png";
import menus from "../../Assets/FoodStyling/dinnerParty.jpeg";
import kitchens from "../../Assets/FoodStyling/kitchens.jpg";
import mushrooms from "../../Assets/FoodStyling/mushrooms.jpeg";

function DesignPortfolio({ photoRef, designRef }) {
  const { showGallery, setShowGallery } = useContext(AppContext);
  const [galleryKey, setGalleryKey] = useState("mushroom"); 

  return (
    <>
    {showGallery && (
      <div style={{
        position: "fixed",
        inset: 0,
        zIndex: 1000,
        background: "#f5f2ed",
        overflow: "auto",
      }}>
        <PhotoGallery galleryKey={galleryKey}/>
      </div>
    )}

    <Container ref={designRef} fluid className="design-section">
      <Container>
        {/* <h1 className="design-heading">DESIGN</h1> */}
        <Row style={{ justifyContent: "center" }}>
          <Col md={6} className="design-card">
            <DesignCard
              imgPath={taipeiMag}
              title="台北老百姓 ORDINARY PEOPLE OF TAIPEI ZINE"
              description="Photographs taken from the streets of Taipei exhibiting the lives and interactions of ordinary people."
              link={"https://www.behance.net/gallery/243238131/Ordinary-People-of-Taipei?"}
            />
          </Col>

          <Col md={6} className="design-card">
            <DesignCard
              imgPath={menus}
              title="MENU DESIGN"
              description="Collection of menu designs for dinner parties I've hosted."
              link="https://www.behance.net/gallery/244385927/Menu-Design"
            />
          </Col>

        </Row>
      </Container>

      <Container ref={photoRef}>
        {/* <h1 className="design-heading">PHOTO</h1> */}
        <Row style={{ justifyContent: "center" }}>
          <Col md={4} className="design-card">
            <DesignCard
              imgPath={squash}
              title="BITE CULINARY MAGAZINE"
              description="Photo projects for BITE"
              link={"https://www.behance.net/gallery/243296755/BITE-Culinary-Magazine"}
            />
          </Col>

          <Col md={4} className="design-card">
          <div onClick={(e) => { e.preventDefault(); setShowGallery(true); setGalleryKey("kitchen")}}>
            <DesignCard
              imgPath={kitchens}
              title="INSIDE THE KITCHEN"
              description="Inside & outside the open kitchen"
            />
            </div>
          </Col>

          <Col md={4} className="design-card">
          <div onClick={(e) => { e.preventDefault(); setShowGallery(true); setGalleryKey("mushroom")}}>
            <DesignCard
              imgPath={mushrooms}
              title="FUNGI"
              description="Pacific Northwest mushroom foraging"
            />
            </div>
          </Col>

        </Row>
      </Container>
      
    </Container>
    </>
  );
}

export default DesignPortfolio;